import React, { createContext, useContext } from 'react';

import { NOOP } from '~/NOOP';

export interface IVehicleOptionsContext {
  eim: string;
  features: string[];
}

export const vehicleOptionsDefaultContext: IVehicleOptionsContext = {
  eim: '',
  features: [],
};

const VehicleOptionsContext = createContext<IVehicleOptionsContext>(vehicleOptionsDefaultContext);
const UpdateVehicleOptionsContext = createContext<React.Dispatch<React.SetStateAction<IVehicleOptionsContext>>>(NOOP);

interface IVehicleOptionsContextProvider {
  value: [IVehicleOptionsContext, React.Dispatch<React.SetStateAction<IVehicleOptionsContext>>];
  children?: React.ReactNode;
}

export const VehicleOptionsProvider = React.memo<IVehicleOptionsContextProvider>(function VehicleOptionsProvider(props) {
  
  return (
    <VehicleOptionsContext.Provider value={props.value[0]}>
      <UpdateVehicleOptionsContext.Provider value={props.value[1]}>
        {props.children}
      </UpdateVehicleOptionsContext.Provider>
    </VehicleOptionsContext.Provider>
  );
});

export const useVehicleOptions = () => useContext(VehicleOptionsContext);
export const useUpdateVehicleOptions = () => useContext(UpdateVehicleOptionsContext);
